import classNames from 'classnames';

import './card.scss';
import { FCC } from '../../../utils/types';

interface Props {
  color?: 'blue' | 'gray-dark';
  className?: string;
  noMargin?: boolean;
}

const Card: FCC<Props> = ({ children, color = '', className = '', noMargin }) => (
  <div className={classNames('card', color, className, { 'no-margin': noMargin })}>{children}</div>
);

export default Card;
